import { GlModal, GlFormGroup } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import csrf from '~/lib/utils/csrf';
import { __, sprintf } from '~/locale';
export default {
    name: 'CsvImportModal',
    i18n: {
        maximumFileSizeText: __('The maximum file size allowed is %{size}.'),
        importIssuesText: __('Import issues'),
        uploadCsvFileText: __('Upload CSV file'),
        mainText: __("Your issues will be imported in the background. Once finished, you'll get a confirmation email."),
        helpText: __('It must have a header row and at least two columns: the first column is the issue title and the second column is the issue description. The separator is automatically detected.')
    },
    actionPrimary: {
        text: __('Import issues')
    },
    actionCancel: {
        text: __('Cancel')
    },
    components: {
        GlModal,
        GlFormGroup
    },
    inject: {
        importCsvIssuesPath: {
            default: ''
        },
        maxAttachmentSize: {
            default: 0
        }
    },
    props: {
        modalId: {
            type: String,
            required: true
        }
    },
    computed: {
        maxFileSizeText () {
            return sprintf(this.$options.i18n.maximumFileSizeText, {
                size: this.maxAttachmentSize
            });
        }
    },
    methods: {
        submitForm () {
            this.$refs.form.submit();
        }
    },
    csrf
};
